<template>
  <a-spin :spinning="loading.page">
    <a-form class="margin-bottom" :form="form">
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Sales Contract">
            <a-select v-decorator="[
              'sales_contract_id',
              {
                rules: [
                  { required: true, message: 'Sales contract is Required' },
                ],
                initialValue: dataInput.customer,
              },]" :disabled="id != '_'" showSearch :filterOption="filterOption" @change="changeSC">
              <a-select-option v-for="item in dataInputOrigin.sales_contract" :key="item.id_sales_contract"
                :value="item.id_sales_contract">{{ item.no_sales_contract }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Kode / Project Name">
            <a-input v-decorator="[
              'kode_project_name',
              {
                rules: [{ required: true }],
                initialValue: dataInput.kode_project_name,
              },
            ]" disabled></a-input>
          </a-form-item>
          <a-form-item label="Customer">
            <a-input v-decorator="[
              'customer',
              {
                rules: [{ required: true }],
                initialValue: dataInput.kode_project_name,
              },
            ]" disabled></a-input>
          </a-form-item>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item label="Project Currency" hidden>
                <a-input v-decorator="[
                  'project_currency',
                  {
                    rules: [{ required: true }],
                    initialValue: dataInput.project_currency,
                  },
                ]" disabled></a-input>
              </a-form-item>
              <a-form-item label="Project Currency">
                <a-input v-decorator="[
                  'project_currency_lbl',
                  {
                    rules: [{ required: true }],
                    initialValue: dataInput.project_currency ? dataInput.project_currency + '-' + dataInput.project_currency_nm : '',
                  },
                ]" disabled></a-input>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
              <a-form-item :label="'Exchange rate 1.00 ' + exchange_lbl">
                <a-input-number v-decorator="[
                  'exchange_rate',
                  {
                    rules: [{ required: true, message: 'Exchange rate is Required' }],
                    initialValue: exchange_lbl == 'IDR to IDR' ? 1 : null,
                  },
                ]" type="number" :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                  :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')" class="m-width-full m-text-align right"
                  :disabled="exchange_lbl == 'IDR to IDR'"></a-input-number>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-form-item label="Include PPN">
              <a-radio-group buttonStyle="solid" :disabled="true" v-decorator="['include_ppn', {
                rules: [{ required: false }], initialValue: dataInput.include_ppn,
              },
              ]" ref="site">
                <a-radio-button value="1" ref="Radio1">Include</a-radio-button>
                <a-radio-button value="0" ref="Radio2">Exclude</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-row>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form-item label="Invoice No">
            <a-input v-decorator="[
              'invoice_no',
              {
                rules: [{ required: true, message: 'Invoice No is Required' }],
              },
            ]"></a-input>
          </a-form-item>
          <a-form-item label="Invoice date">
            <a-date-picker placeholder="Select Date" :format="getDefaultDateFormat" v-decorator="[
              'invoice_date',
              {
                rules: [
                  { required: true, message: 'Invoice date is Required' },
                ],
                initialValue: dataInput.invoice_date,
              },
            ]" />
          </a-form-item>
          <a-form-item label="Upload File Support">
            <a-upload :showUploadList="true" :fileList="push" :beforeUpload="beforeUpload" :remove="handleRemove"
              v-decorator="[
                'upload',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Upload File Support is Required',
                    },
                  ],
                  valuePropName: 'push',
                },
              ]">
              <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import _ from "lodash";

export default {
  name: "information",
  props: {
    id: String,
    information: {},
    combo_pimpro: {},
  },
  mixins: [CurrencyFormat],
  components: {},
  data() {
    return {
      dataInput: [],
      dataInputOrigin: [],
      customer: "",
      bankAccount: [],
      bankAccountStatus: false,
      push: [],
      deliverable: [],
      loading: {
        page: false
      }
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStandartFormatDate", "getDefaultDateFormat"]),
    exchange_lbl() {
      return this.dataInput.project_currency && this.dataInput.project_currency != "IDR" ? this.dataInput.project_currency + " to IDR" : "IDR to IDR"
    }
  },
  created() {
    this.fetch("first_load", null);
  },
  methods: {
    moment,
    fetch(types, idtemp) {
      this.loading.page = true;

      let param = this.id != "_" || types == "onchange_load" ? {
        tlc: this.getAuth.username,
        id: types == "onchange_load" ? idtemp : this.id,
      } : {
        tlc: this.getAuth.username,
      }
      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "akuntansi/ar_akuntansi/create_ar_acc",
        params: param,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.loading.release = false;
        this.loading.process = false;
      });

      // const bank = axios({
      //   method: "get",
      //   url: this.$serviceUrl + "bkm/bank",
      //   params: {},
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password,
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey,
      //   },
      // }).catch((err) => {
      //   console.log(err);
      //   this.loading.release = false;
      //   this.loading.process = false;
      // });

      return new Promise((resolve, reject) => {
        axios
          .all([
            proses.catch((err) => {
              this.loading.page = false;
              if (!err.response) {
                let responses = Object.assign({}, err.response.data);
                this.displayMessageValue("error", responses);
                this.$router.go(-1);
              } else {
                this.displayMessage("denied-manifest");
                this.$router.push({ name: "beranda" });
              }
              return null;
            }),
            // bank.catch((err) => {
            //   this.loading.page = false;
            //   if (!err.response) {
            //     let responses = Object.assign({}, err.response.data);
            //     this.displayMessageValue("error", responses);
            //     this.$router.go(-1);
            //   } else {
            //     this.displayMessage("denied-manifest");
            //     this.$router.push({ name: "beranda" });
            //   }
            //   return null;
            // }),
          ])
          .then((response) => {
            if (types == 'first_load') this.dataInputOrigin = response[0].data
            this.dataInput = response[0].data;
            if (!this.dataInput.invoice_date) {
              this.dataInput.invoice_date = null;
            } else {
              this.dataInput.invoice_date = moment(this.dataInput.invoice_date);
            }
            // let bankResponse = response[1].data.data;
            // if (this.dataInput.sales_contract_id === null) {
            //   this.bankAccountStatus = false;
            //   this.bankAccount = bankResponse.filter(
            //     (obj) =>
            //       obj.currency &&
            //       obj.currency.indexOf(this.dataInput.project_currency) >= 0
            //   );
            // } else {
            //   this.bankAccountStatus = true;
            //   this.bankAccount = bankResponse;
            // }
            // this.bank = this.dataInput.sales_contract_id;
            this.deliverable = response[0].data.detail_deliverable;
            this.loading.page = false;
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleRemove() {
      this.push = [];
    },
    save() {
      this.confirmMessage("confirm-save");
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        // let bnk = _.filter(this.bankAccount, {
        //   sales_contract_id: values.sales_contract_id,
        // });
        values.currency = this.dataInput.project_currency;

        Event.$emit("emitChild", {
          values,
          deliverable: this.dataInput.deliverable,
          termin_dtl: this.dataInput.termin_dtl,
          SC: this.dataInput,
        });
      });
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.push = [file];
        return false;
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    changeSC(val) {
      this.fetch("onchange_load", val);
    }
  },
  mounted() { },
  beforeDestroy() { },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
};
</script>

<style></style>